/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getIncidentStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getIncidentStatusByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetIncidentStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getIncidentStatusByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getIncidentStatusByIdPayloadRegExpTwo)]).optional()
});

export type GetIncidentStatusById = zod.input<typeof GetIncidentStatusById>;
export type GetIncidentStatusByIdOutput = zod.output<typeof GetIncidentStatusById>;
